import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { Typography } from '@chegg-ui/typography';
import { Radio } from '@chegg-ui/radio';
import { ListItemContainer, ListContainer, ProductSection, SelectionWrapper, StyledCheckIcon, StyledPrice, StyledBasePrice, StyledPriceContainer, StyledCouponAppliedText } from '../styled';
export var ListItem = function ListItem(_ref) {
  var text = _ref.text;
  return /*#__PURE__*/React.createElement(ListItemContainer, null, /*#__PURE__*/React.createElement(StyledCheckIcon, null), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    variantType: "normal"
  }, text));
};
var ProductDetails = function ProductDetails(_ref2) {
  var _itemData$;
  var content = _ref2.content,
    price = _ref2.price,
    selectedProduct = _ref2.selectedProduct,
    selectProduct = _ref2.selectProduct,
    itemData = _ref2.itemData,
    orderSummaryContent = _ref2.orderSummaryContent,
    taxInfo = _ref2.taxInfo,
    isLoaded = _ref2.isLoaded,
    basePrice = _ref2.basePrice,
    isDiscounted = _ref2.isDiscounted,
    isCouponApplied = _ref2.isCouponApplied,
    couponAppliedText = _ref2.couponAppliedText;
  var items = content.items,
    line1 = content.line1;
  var productType = (_itemData$ = itemData[0]) === null || _itemData$ === void 0 ? void 0 : _itemData$.productType;
  var replaceItemData = itemData.map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      replace: true
    });
  });
  var handleChange = function handleChange(e) {
    selectProduct({
      productType: e.target.id,
      itemData: replaceItemData,
      orderSummaryContent: orderSummaryContent,
      taxInfo: taxInfo
    });
  };
  return /*#__PURE__*/React.createElement(ProductSection, {
    "data-test": "product-details".concat(productType)
  }, /*#__PURE__*/React.createElement(SelectionWrapper, null, /*#__PURE__*/React.createElement(Radio, {
    checked: selectedProduct.productType === productType,
    inputId: productType,
    onChange: handleChange,
    disabled: !isLoaded
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    variantType: "heavy"
  }, line1)), /*#__PURE__*/React.createElement(StyledPriceContainer, null, isCouponApplied && couponAppliedText && /*#__PURE__*/React.createElement(StyledCouponAppliedText, {
    variant: "body1",
    variantType: "bold"
  }, couponAppliedText), /*#__PURE__*/React.createElement(StyledPrice, {
    variant: "body1",
    variantType: "bold",
    color: "",
    "data-test": "".concat(productType, "-price"),
    isDiscounted: isDiscounted
  }, isCouponApplied ? price : "".concat(price, "/mo")), isDiscounted && basePrice && /*#__PURE__*/React.createElement(StyledBasePrice, {
    variant: "body1"
  }, "".concat(basePrice, "/mo")))), /*#__PURE__*/React.createElement(ListContainer, null, items.map(function (text, idx) {
    return /*#__PURE__*/React.createElement(ListItem, {
      key: idx,
      text: text
    });
  })));
};
export default ProductDetails;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/views/CartCheckout/internals/ProductDetails.js
// module id = 4709
// module chunks = 11